
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosAditivosConvenio {
    numero: string
    ano: string
    idConvenio: number
    idNatureza: number
    justificativa: string

    constructor() {
        this.limpar()
    }

    limpar(): void {
        this.numero = ''
        this.ano = ''
        this.idConvenio = 0
        this.idNatureza = 0
        this.justificativa = ''
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.ano)
            data.append("filtroAno", this.ano)
        if (this.numero)
            data.append("filtroNumero", this.numero)
        if (this.idConvenio > 0)
            data.append("filtroConvenio", String(this.idConvenio))
        if (this.idNatureza > 0)
            data.append("filtroNaturezaAjuste", String(this.idNatureza))
        if (this.justificativa)
            data.append("filtroJustificativa", this.justificativa)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.ano)
            retorno += '&filtroAno=' + this.ano
        if (this.numero)
            retorno += '&filtroNumero=' + this.numero
        if (this.idConvenio > 0)
            retorno += '&filtroConvenio=' + String(this.idConvenio)
        if (this.idNatureza > 0)
            retorno += '&filtroNaturezaAjuste=' + String(this.idNatureza)
        if (this.justificativa)
            retorno += '&filtroJustificativa=' + this.justificativa
        return retorno
    }
}